import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/UseAuth';
import JwtUtils from '../../utils/jwtUtils';
import authStorage from '../../utils/authStorage';

/**
 * Route wrapper: exige une authentification
 * Version entreprise (NSIA) : pas de logique d'abonnement
 */
const ProtectedRoute = ({ children, requiredRole = null, requiredPermission = null }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  const userIsAuthenticated = isAuthenticated || (user && JwtUtils.isAuthenticated());

  if (!userIsAuthenticated) {
    authStorage.removeItem('token');
    authStorage.removeItem('auth_user');
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (requiredRole && !JwtUtils.hasRole(requiredRole)) {
    return (
      <Navigate
        to="/admin/login"
        state={{ from: location, error: `Access denied: Requires ${requiredRole} role` }}
        replace
      />
    );
  }

  if (requiredPermission && !JwtUtils.hasPermission(requiredPermission)) {
    return (
      <Navigate
        to="/admin/login"
        state={{ from: location, error: `Access denied: Requires ${requiredPermission} permission` }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
